import { useQuery } from '@tanstack/react-query';
import { userQueries } from '../api/user-queries';
import type { User } from './schema';

export function useUsers(enabled = true) {
  return useQuery({ ...userQueries.list(), enabled });
}

/** One staff member by id — enabled only while an edit form is open. */
export function useUser(id: User['id'] | undefined) {
  return useQuery({
    ...userQueries.detail(id ?? ''),
    enabled: id !== undefined,
  });
}
export function useUserLocations() {
  return useQuery(userQueries.locations());
}
export function useEmployeeLocations(id: string | undefined) {
  return useQuery(userQueries.employeeLocations(id ?? ''));
}
